import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgPaperPlaneOutlined = ({ size, title = 'PaperPlaneOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19.5 4.5l-8.25 8.25M19.5 4.5l-5.25 15-3-6.75-6.75-3 15-5.25z"
        />
    </svg>
);

export default withIcon(SvgPaperPlaneOutlined);
